import { render } from "./AllTrainingsView.vue?vue&type=template&id=3333f286"
import script from "./AllTrainingsView.vue?vue&type=script&lang=js"
export * from "./AllTrainingsView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__